/*
* Project: LegalPlace assistant
* File: src/components/buy/header.js
* Author: Nasreddine DAIFALLAH
* Version: 1.0
*/


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ceTogglePack, packEntrepreneurChoosePack, packEntrepreneur } from '../../redux/actions/checkout_operations';
import lpevents from '../../tracking/lpevents';
import { lpPattern, P_BACK } from '../../tracking/pattern_detector';
import { _lp } from '../../logic/wording';
import lpApp from '../../app/lp_app';
import { HARCODED_CHECKOUT_META_IDS } from '../../constants/hardcoded_checkout';
import { withRouter } from "react-router-dom";
import leftChevronIcon from "../../styles/img/newCheckout/chevron-left.svg";



class _Header extends Component {
  constructor(props) {
    super(props);
    this.goTopack = this.goTopack.bind(this);
  }

  goTopack(hardCodedMeta = true) {
    lpevents.trackGTMGAEvent('Checkout retour', 'Clic', this.props.title)
    // intermediate page => reload the page
    if (this.props.packEntrepreneur && this.props.packEntrepreneur.backHeaderBtn) {
      this.props.onPackEntrepreneurHeaderBtn(false)
      this.props.onPackEntrepreneurChoosePack(undefined)
      return;
    }
    if (this.props.togglePack && hardCodedMeta) {
      this.props.goPack(false, this.props.selectedPack);
    } else {
      window.location.href = `/contrats/${lpApp.contractTitle}/continuer/${lpApp.contractUniqid}`;
    }

    document.getElementsByTagName("html")[0].removeAttribute('style');
  }

    render(){
        return (<div>
                { (HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1) ?
                (
                    (<div className="checkout-top">
                        <div className="container">
                            <div className="tb-nav">
                                <a className="link-gd" style={{cursor: "pointer"}} onClick={this.goTopack}>
                                    <i className="icn-arrow-left"></i>Retour
                                </a>
                            </div>
                        </div>
                    </div>)
                 ) :
                (<div className="container">
                  <div className="title-bar">
                    <div className="tb-headings">
                        <a className="link-gd" title={_lp("Retourner au Questionnaire")} onClick={this.props.goBack}>
                          {lpApp.contractMetaId === 302  ? (
                          <img src={leftChevronIcon} alt="" />
                          ) : (
                            <i className="icn-arrow-left"></i>
                          )}
                          {lpApp.contractMetaId === 302 ? 'Retour': _lp('Modifier mes réponses')}
                        </a>
                        <h2 className="tb-title" style={lpApp.contractMetaId === 302 ? {display: 'none'}: {}}>
                          {lpApp.references.customs.get('checkout_title') == 'NONE' ? _lp("Votre ") + this.props.title + _lp(" est prêt") : lpApp.references.customs.get('checkout_title')}
                        </h2>
                        <h3 className="tb-subtitle">
                    {(lpApp.references.customs.custom && lpApp.references.customs.custom.uniqpack) ? "" : _lp("Choisissez l'offre qui vous correspond")}
                        </h3>
                      </div>
                    </div>
                    </div>)}
                </div>)
    }
}

const mapStateToProps = state => {

  return {
  title: state.contract.name,
  togglePack: state.checkout_operations.togglepack,
  packEntrepreneur: state.checkout_operations.packEntrepreneur,
  selectedPack: state.checkout_operations.pack
}};

const mapDispatchToProps = (dispatch, ownProps) => ({
  goBack: () => {
    // #event
    lpevents.track('Modifier mon document', {});
    lpPattern.trackLastAction(P_BACK);
    lpevents.trackGTMGAEvent('Checkout retour', 'Clic', lpApp.getState().contract.name)
    lpPattern.sendAndResetTracker();
    ownProps.history.push(
      `/contrats/${lpApp.contractTitle}/continuer/${lpApp.contractUniqid}/${Object.keys(lpApp.indexes.real_sections.sections).length}`
      );
  },
  goPack: (val, id) => {
    dispatch(ceTogglePack(val, id));
  },
  onPackEntrepreneurChoosePack: (val) => {
    dispatch(packEntrepreneurChoosePack(val));
  },

  onPackEntrepreneurHeaderBtn: (val) => {
    dispatch(packEntrepreneur(val));
  }
});

const LpHeader = withRouter(connect(mapStateToProps, mapDispatchToProps)(_Header));

export default LpHeader;



// WEBPACK FOOTER //
// ./src/components/buy/header.js